var map = {
	"./en.json": "./ClientApp/locale/genesis/en.json",
	"./it.json": "./ClientApp/locale/genesis/it.json",
	"./pl.json": "./ClientApp/locale/genesis/pl.json",
	"./pt.json": "./ClientApp/locale/genesis/pt.json",
	"./zh-CN.json": "./ClientApp/locale/genesis/zh-CN.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/locale/genesis ./ClientApp/locale/genesis sync recursive ^\\.\\/.*\\.json$";